import {createContext, useContext} from 'react';
import {defaultContext} from './reducer/model';

export const EmailContext = createContext(defaultContext);

export const useEmailContext = () => useContext(EmailContext);
